(function Homeports($, Adzuki)
{
	"use strict";

	var $container = $("#sailings"),
	    $modal     = $(".modal"),
	    homeports,
	    resizeSailingsTable;

	$(document).ready(function documentReady()
	{
		Adzuki.onload('Itineraries/homeports', function onload()
		{
			resizeSailingsTable = Adzuki.Debounce(function _resize()
			{
				// var offset = 320;

				// // detect the transform of the sidebar to see if it's visible
				// if ($(".sidebar").css('transform').split(', ')[4] === '-300') {
				// 	offset = 30;
				// }

				// $(".box.table-responsive").css('width', $(window).width() - offset);
			}, 250);

			homeports = new Adzuki.Map('#homeports-map');
			homeports.markerCallback = loadSailingsForCity;

			Adzuki.Ajax.get('/Itineraries/getHomeportMapMarkers')
			.then(function populate(ports) {
				homeports.populate(ports.ports, false);

				if (ports.select_marker_id === null) {
					homeports.viewAllMarkers();
				} else {
					homeports.selectMarker(ports.select_marker_id);
					homeports.map.setZoom(5); // eslint-disable-line no-magic-numbers
				}
			});

			$(".map select#region").on('change', function selectRegion() {
				panToRegion($(this).val());
			});

			// change cabin/nights options
			$('#options input[type="radio"]').on('change', function changeOpts() {
				loadSailingsForCity(homeports.selectedMarker);
			});

			$container.on('click', '.city-link a', function showCityInfo(e) {
				var $self = $(this);
				e.preventDefault();
				$modal.find('.modal-title').text($self.data('title'));
				$modal.find('.modal-body').html($self.data('content'));
				$modal.modal('show');
			});

			$container.on('click', '.nearby-airports a', function showAirports(e) {
				e.preventDefault();
				$modal.find('.modal-title').text('Nearby Airports');
				$modal.find('.modal-body').html($("#airport-list").html());
				$modal.modal('show');
			});

			$container.on('click', '.shore-excursions a', function showExcursions(e)
			{
				var $self   = $(this),
				    city    = $self.data('city'),
				    city_id = $self.data('city-id');

				e.preventDefault();

				$modal.addClass('wide');
				$modal.find('.modal-body').text('Loading shore excursions...');

				Adzuki.Ajax.get('/Excursions/getByCityId/' + city_id)
				.then(function _showExcursions(html) {
					$modal.find('.modal-body').html(html);
					$modal.find('[data-toggle^="tooltip"]').tooltip();
				});

				$modal.find('.modal-title').text('Shore excursions for ' + city);
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});


			$(document).on('click', '.modal .info-link a', function showInfo(e) {
				e.preventDefault();
				$(this).siblings('.content').slideToggle();
			});

			$(window).on('resize', resizeSailingsTable);
		});
	});


	/**
	 * Pan the map to the specified region, from the select box in the map.
	 */
	function panToRegion(region)
	{
		Adzuki.Ajax.get('/Itineraries/getRegion/'+region)
		.then(function _panToRegion(_region) {
			homeports.panTo(_region.lat, _region.lng, _region.zoom);
		});
	}


	/**
	 * Load and populate table of sailings for the selected marker (city).
	 */
	function loadSailingsForCity(marker)
	{
		var city_id = marker.city_id,
		    cabin   = $('input[name="cabin_type"]:checked').val(),
		    nights  = $('input[name="nights"]:checked').val(),
		    $inputs = $('input[type="radio"]'),
		    $loader = $(".finding-sailings");

		$inputs.prop('disabled', true);
		$loader.removeClass('hidden');

		Adzuki.Ajax.get('/Itineraries/getSailingsForPort/'+city_id+'/'+cabin+'/'+nights)
		.then(function appendSailingsTable(data)
		{
			$inputs.prop('disabled', false);
			$loader.addClass('hidden');

			if (data.status === false) {
				Adzuki.StatusMessage('Error', data.message);
				return;
			}

			$(".homeports #sailings").html(data).find('[data-toggle^="tooltip"]').tooltip();
			resizeSailingsTable();
		});
	}

}(jQuery, window.Adzuki || {}));
